import { render, staticRenderFns } from "./serviceDefine.vue?vue&type=template&id=c65b5b8e&scoped=true&"
import script from "./serviceDefine.vue?vue&type=script&lang=js&"
export * from "./serviceDefine.vue?vue&type=script&lang=js&"
import style0 from "./serviceDefine.vue?vue&type=style&index=0&id=c65b5b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65b5b8e",
  null
  
)

export default component.exports